export default "__VITE_ASSET__BV5VBTrn__"